import React from 'react';

import moment from 'moment'

import { paymentApplicationTypes } from './actions'

const initialState = {
    isFetching: false,
    paymentApplications: {}
}

const makeApplicationsByContractNumber = (paymentApplications) => {
    let paymentApplicationsByContractNumber = {}

    if (paymentApplications === null || paymentApplications.Customer.PaymentApplicationList === null) {
        return {}
    }

    for (var paymentApplicationList of paymentApplications.Customer.PaymentApplicationList) {
        if (paymentApplicationList === null || paymentApplicationList.PaymentApplication === null) {
            continue;
        }
        paymentApplications = paymentApplicationList.PaymentApplication
        paymentApplication.ApplicationDate = moment.utc(paymentApplication.ApplicationDate, "DD.MM.YYYY")
        paymentApplication.ApplicationStatus = +paymentApplication.ApplicationStatus
        if (paymentApplicationsByContractNumber.hasOwnProperty(paymentApplication.ContractId)) {
            paymentApplicationsByContractNumber[paymentApplication.ContractId].push(paymentApplication)
        }
        else {
            paymentApplicationsByContractNumber[paymentApplication.ContractId] = [paymentApplication]
        }
    }
    for (var key of Object.keys(paymentApplicationsByContractNumber)) {
        paymentApplicationsByContractNumber[key] = paymentApplicationsByContractNumber[key].sort((a, b) => a.valueOf() - b.valueOf())
    }
    return paymentApplicationsByContractNumber
}

export function paymentApplications(state = initialState, action) {

    switch(action.type) {

        case paymentApplicationTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case paymentApplicationTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.paymentApplications = makeApplicationsByContractNumber(action.data)

            return state


        default:
            return state
    }
}